@if (busy) {
  <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
}
<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  @if (recoveryContext && !postRecoveryContext) {
    <div>
      <div [innerHTML]="recoveryMessage"></div>
      <form [formGroup]="dialogForm" class="mt-3">
        <mat-form-field  appearance="outline" class="w-100">
          <mat-label>Recovery Key</mat-label>
          <input matInput placeholder="" formControlName="code" required>
          @if (dialogForm.controls.code.errors?.required) {
            <mat-error>Recovery Key is required</mat-error>
          }
        </mat-form-field>
      </form>
    </div>
  }
  @if (postRecoveryContext) {
    <div>
      <div [innerHTML]="postRecoveryMessage"></div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions >
  <div class="w-100 flex-row justify-end items-center mt-3 p-2">
    @if (showCancelButton) {
      <a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
    }
    <a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>
